import { Component } from '@angular/core';
import { HeroSectionComponent } from '../../shared/components/hero-section/hero-section.component';
import { TranslateModule } from '@ngx-translate/core';

import { MatExpansionModule } from '@angular/material/expansion';
import { DarkModeService } from '../../shared/services/darkmode.service';
import { AccordionFaqPrivacyAndSecurityComponent } from '../../shared/components/accordion-faq-privacy-and-security/accordion-faq-privacy-and-security.component';
import { AccordionFaqTechnicalSupportComponent } from '../../shared/components/accordion-faq-technical-support/accordion-faq-technical-support.component';
import { AccordionFaqUsingAppComponent } from '../../shared/components/accordion-faq-using-app/accordion-faq-using-app.component';
import { AccordionFaqGeneralQuestionsComponent } from '../../shared/components/accordion-faq-general-questions/accordion-faq-general-questions.component';

@Component({
  selector: 'app-frequently-asked-questions',
  imports: [
    HeroSectionComponent,
    TranslateModule,
    MatExpansionModule,
    AccordionFaqPrivacyAndSecurityComponent,
    AccordionFaqTechnicalSupportComponent,
    AccordionFaqUsingAppComponent,
    AccordionFaqGeneralQuestionsComponent,
  ],
  templateUrl: './frequently-asked-questions.component.html',
  styleUrl: './frequently-asked-questions.component.scss',
})
export class FrequentlyAskedQuestionsComponent {
  panelOpenState = false;
  darkMode = false;

  principalAccordion: {
    index: number;
    expanded: boolean;
  }[] = [
    {
      index: 0,
      expanded: false,
    },
    {
      index: 1,
      expanded: false,
    },
    {
      index: 2,
      expanded: false,
    },
    {
      index: 3,
      expanded: false,
    },
    {
      index: 4,
      expanded: false,
    },
    {
      index: 5,
      expanded: false,
    },
    {
      index: 6,
      expanded: false,
    },
    {
      index: 7,
      expanded: false,
    },
    {
      index: 8,
      expanded: false,
    },
    {
      index: 9,
      expanded: false,
    },
    {
      index: 10,
      expanded: false,
    },
  ];

  constructor(private darkmodeService: DarkModeService) {
    this.darkmodeService.isDarkMode.subscribe((isDark) => {
      this.darkMode = isDark;
    });
  }

  onExpandChange(index: number) {
    this.principalAccordion[index].expanded =
      !this.principalAccordion[index].expanded;
  }
}
